import { render, staticRenderFns } from "./ProductBase.vue?vue&type=template&id=77ac5950&"
import script from "./ProductBase.vue?vue&type=script&lang=js&"
export * from "./ProductBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports